module.exports = __webpack_public_path__ + "static/media/tasco.8ff5f049.png";